import type { PageElementProps } from '@components/Projects/TakeProject';
import { type FC } from 'react';

import type { CanvasAnswer, EssayCopilotAnswer } from '@app/@types/redux/answer';
import type { EssayCopilotOptions } from '@app/@types/redux/pageElement';
import { getPageElementDisabledState } from '@state/selectors/projects';
import EssayCopilotView from './EssayCopilotView';

export interface ExternalPageElementProps extends PageElementProps {
  answers?: CanvasAnswer;
  preview?: boolean;
}
const EssayCopilot: FC<PageElementProps> = (props) => {
  const { pageElement, answer, state } = props;

  const { id: pageElementId } = pageElement;
  const options = pageElement.attributes.options as EssayCopilotOptions;
  const currentAnswer = props.currentAnswer as EssayCopilotAnswer | undefined;

  const disabled = getPageElementDisabledState(state, pageElementId);

  return (
    <EssayCopilotView
      currentAnswer={currentAnswer}
      options={options}
      preview={disabled}
      answer={answer}
      pageElementId={pageElementId}
    />
  );
};
export default EssayCopilot;
